import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    toggleRightSidebar,
    changeTopbarTheme,
    changeLayoutWidth
} from "../../store/actions";

// Layout Related Components
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import OfflineBanner from "../OfflineBanner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import logoWhite from '../../assets/images/logo-light.png';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
        };
        this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
        this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
    }

    toggleRightSidebar() {
        this.props.toggleRightSidebar();
    }

    capitalizeFirstLetter = string => {
        return string.charAt(1).toUpperCase() + string.slice(2);
    };

    closeSidebarOnMobile = () => {
        if (window.innerWidth <= 992 && document.body.classList.contains('sidebar-enable')) {
            document.body.classList.remove('sidebar-enable');
        }
    };

    componentDidUpdate(prevProps) {
        // Fechar sidebar ao navegar em mobile
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.closeSidebarOnMobile();
        }

        if (prevProps !== this.props) {
            if (this.props.isPreloader === true) {
                document.getElementById('preloader').style.display = "block";
                document.getElementById('status').style.display = "block";

                setTimeout(function () {

                    document.getElementById('preloader').style.display = "none";
                    document.getElementById('status').style.display = "none";

                }, 2500);
            }
            else {
                document.getElementById('preloader').style.display = "none";
                document.getElementById('status').style.display = "none";
            }
        }
    }

    componentDidMount() {


        // Scroll Top to 0
        window.scrollTo(0, 0);
        let _currentage = this.capitalizeFirstLetter(this.props.location.pathname);

        document.title = "Mellro";
        if (this.props.leftSideBarTheme) {
            this.props.changeSidebarTheme(this.props.leftSideBarTheme);
        }

        if (this.props.layoutWidth) {
            this.props.changeLayoutWidth(this.props.layoutWidth);
        }

        if (this.props.leftSideBarType) {
            this.props.changeSidebarType(this.props.leftSideBarType);
        }
        if (this.props.topbarTheme) {
            this.props.changeTopbarTheme(this.props.topbarTheme);
        }

        if (this.props.showRightSidebar) {
            this.toggleRightSidebar();
        }
    }
    toggleMenuCallback = () => {
        if (window.innerWidth <= 992) {
            // Mobile viewport: toggle classe sidebar-enable no body
            if (document.body.classList.contains('sidebar-enable')) {
                document.body.classList.remove('sidebar-enable');
            } else {
                document.body.classList.add('sidebar-enable');
            }
        } else {
            // Desktop viewport: condensed (icon-only 70px) ↔ default (240px)
            if (this.props.leftSideBarType === "default") {
                this.props.changeSidebarType("condensed", false);
            } else {
                this.props.changeSidebarType("default", false);
            }
        }
    };

    render() {
        return (
            <React.Fragment>
                <OfflineBanner />
                <div id="preloader">
                    <div id="status">
                        <div className="spinner">
                            <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                    </div>
                </div>


                <div id="layout-wrapper">
                    <div className="mobile-topbar">
                        <img src={logoWhite} alt="Mellro" height="20" className="d-block" />
                        <button
                            className="mobile-topbar__hamburger"
                            onClick={this.toggleMenuCallback}
                            aria-label="Abrir menu"
                        >
                            <FontAwesomeIcon icon={faBars} />
                        </button>
                    </div>
                    <Sidebar
                        theme={this.props.leftSideBarTheme}
                        type={this.props.leftSideBarType}
                        isMobile={this.state.isMobile}
                        toggleMenuCallback={this.toggleMenuCallback}
                    />
                    <div
                        className="sidebar-mobile-backdrop"
                        onClick={this.closeSidebarOnMobile}
                    />
                    <div className="main-content">
                        {this.props.children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


const mapStatetoProps = state => {
    return {
        ...state.Layout
    };
};
export default connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    toggleRightSidebar,
    changeTopbarTheme,
    changeLayoutWidth
})(withRouter(Layout));

